(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("EvmChains", [], factory);
	else if(typeof exports === 'object')
		exports["EvmChains"] = factory();
	else
		root["EvmChains"] = factory();
})(this, function() {
return 